import { Field } from 'formik';
import formikMetaToState from '../../helpers/formikMetaToState';
import { TextArea, TextAreaProps } from '../TextArea';

export const FormikTextArea = (props: TextAreaProps & { name: string }) => {
  const { name } = props;
  return (
    <Field name={name}>
      {({ field, meta }: any) => {
        const { error, state } = formikMetaToState(meta);
        return <TextArea {...field} {...props} error={error} state={state} />;
      }}
    </Field>
  );
};
